import React from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import PopupAnchor from "./popup-anchor";
import { fetchSales } from "../views/sales/territory-common";

/*
 * Shared order-status multi-select for the Territory pages. Fetches the tenant's
 * live status vocabulary from /sales/status (whatever statuses the ERP emits show
 * up automatically); empty selection = all booked (the backend default). Emits the
 * selected statuses as an array via onChange — the caller joins them into ?status=.
 *
 * Props: range · value (string[]) · onChange(string[]) · width
 */
export default class StatusFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
    this._alive = true;
  }
  componentDidMount() {
    this.loadList();
  }
  componentDidUpdate(prev) {
    if (prev.range !== this.props.range) this.loadList();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async loadList() {
    try {
      const rows = await fetchSales(`/sales/status/${this.props.range}`);
      const seen = new Set();
      const list = [];
      (rows || []).forEach(r => {
        const s = r && (r.orderStatus || r.status || r.OrderStatus);
        if (s && s !== "(unspecified)" && !seen.has(s)) {
          seen.add(s);
          list.push(s);
        }
      });
      if (this._alive) this.setState({
        list
      });
    } catch (e) {/* leave empty = all */}
  }
  render() {
    // Hidden when the workspace has no order statuses to choose from (e.g. a retailer whose feed
    // carries none), unless a status is already selected.
    if (!this.state.list.length && !(this.props.value || []).length) return null;
    return /*#__PURE__*/React.createElement(PopupAnchor, null, anchor => /*#__PURE__*/React.createElement(MultiSelect, {
      data: this.state.list,
      value: this.props.value || [],
      onChange: e => this.props.onChange(e.value),
      placeholder: "All statuses",
      style: {
        width: this.props.width || 260
      },
      popupSettings: anchor ? {
        appendTo: anchor
      } : undefined
    }));
  }
}